// extracted by mini-css-extract-plugin
export default {"horizontal":"AgDivider_horizontal__Ccuf+","vertical":"AgDivider_vertical__ypGB1"};